import apiClient from './api';

const logService = {
    // 獲取操作日誌列表
    async getLogs(params = {}) {
        try {
            const response = await apiClient.get('/logs', { params });
            return response.data;
        } catch (error) {
            console.error('獲取操作日誌失敗:', error);
            throw error;
        }
    },

    // 匯出日誌
    async exportLogs(params = {}) {
        try {
            const response = await apiClient.get('/logs/export', {
                params,
                responseType: 'blob'
            });

            // 觸發文件下載
            const filename = `logs_${new Date().toISOString().split('T')[0]}.xlsx`;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();

            return response.data;
        } catch (error) {
            console.error('匯出日誌失敗:', error);
            throw error;
        }
    }
};

export { logService };
export default logService;